import React from "react"

import { Box, ListItemButton, Typography } from "@mui/material"
import Icon from "@mdi/react"

import { Action } from "models"

export interface NotificationItemData {
	notification: Action
	title: string
	subtitle: string
	dateLabel: string
	iconPath: string
	isRead: boolean
}

interface NotificationListItemProps extends NotificationItemData {
	onOpenDetails: (notification: Action) => void
}

const NotificationListItem: React.FC<NotificationListItemProps> = ({
	notification,
	title,
	subtitle,
	dateLabel,
	iconPath,
	isRead,
	onOpenDetails,
}) => {
	return (
		<ListItemButton
			onClick={() => onOpenDetails(notification)}
			sx={{ px: 2, py: 1.5 }}
		>
			<Box sx={{ display: "flex", width: "100%", alignItems: "center", gap: 1.25 }}>
				<Box sx={{
					width: 34,
					height: 34,
					borderRadius: "50%",
					backgroundColor: isRead ? "#DEE2E6" : "#EF5350",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}>
					<Icon
						path={iconPath}
						size={0.8}
						color={isRead ? "#6C757D" : "#FFFFFF"}
					/>
				</Box>
				<Box sx={{ minWidth: 0 }}>
					<Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2, mb: 0.3 }} noWrap>
						{title}
					</Typography>
					<Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1.1 }}>
						{dateLabel}
					</Typography>
					{subtitle && (
						<Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1.1 }} noWrap>
							{subtitle}
						</Typography>
					)}
				</Box>
			</Box>
		</ListItemButton>
	)
}

export default NotificationListItem
